module.exports = __webpack_public_path__ + "img/Simple Brown.298bfe73.jpg";